import React from "react";
import { useTranslation } from 'react-i18next';

export default function Interier() {
  const { t } = useTranslation();

  return (
    <div className="sonata-exterior">
      <div className="second-parth-elantra">
        <div>
          <h2 className="exterier-header">{t("elantra.interier1")} </h2>
          
        </div>
      </div>
      <div className="first-parth-sonata">
        <div className="tit-wrap">
          <h1>{t("elantra.interier2")}</h1>
          <p>
          {t("elantra.interier3")}
          </p>
          <img
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/design/interior/elantra-design-interior-accordion-pc.jpg"
            alt="elantra"
          />
        </div>
{/* 
        <div className="max-comf">
          <div>
          <h2 className="max-comf-header">{t("elantra.interier4")}</h2>
          <p className="container">
          {t("elantra.interier5")}
          </p>
            <img
              alt="comf-img"
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/design/interior/elantra-design-interior-pc.jpg"
            />
          </div>
          
        </div> */}
        <div className="max-comf">
          <div>
          <h2 className="max-comf-header">{t("elantra.interier6")}</h2>
          <p>
          {t("elantra.interier7")}
          </p>
            <img
              alt="comf-img"
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/elantra-cn7-design-64-color-mood-lamp-original.jpg"
            />
          </div>
          
        </div>
      </div>
    </div>
  );
}
